import React, { useContext } from 'react';
import { OTPInput, OTPInputContext, REGEXP_ONLY_DIGITS } from 'input-otp';
import { cn } from '@guestyci/arc';

const InputOTP = React.forwardRef(({ containerClassName, ...props }, ref) => (
  <OTPInput
    ref={ref}
    maxLength={props.maxLength ?? 6}
    pattern={props.pattern ?? REGEXP_ONLY_DIGITS}
    autoComplete="one-time-code"
    inputMode="numeric"
    pushPasswordManagerStrategy="none"
    containerClassName={cn('gst-flex gst-items-center gst-gap-2', containerClassName)}
    {...props}
  />
));
InputOTP.displayName = 'InputOTP';

const InputOTPGroup = React.forwardRef(({ ...props }, ref) => (
  <div ref={ref} className="gst-flex gst-items-center gst-gap-1" {...props} />
));
InputOTPGroup.displayName = 'InputOTPGroup';

const InputOTPSlot = React.forwardRef(({ index, className, ...props }, ref) => {
  const inputOTPContext = useContext(OTPInputContext);
  const { char, isActive } = inputOTPContext.slots[index] ?? {};

  return (
    <div
      ref={ref}
      data-testid="otp-slot"
      className={cn(
        'gst-relative gst-flex gst-h-12 gst-w-10 gst-items-center gst-justify-center',
        'gst-border-solid gst-rounded-md gst-text-base gst-font-medium gst-transition-all',
        isActive ? 'gst-border-2 gst-border-primary' : 'gst-border gst-border-gray-300',
        className,
      )}
      {...props}
    >
      {char}
    </div>
  );
});
InputOTPSlot.displayName = 'InputOTPSlot';

export { InputOTP, InputOTPGroup, InputOTPSlot };
